var $434ac52446b12663$exports = {};
$434ac52446b12663$exports = {
    "(optional)": `(opcionalno)`,
    "(required)": `(obvezno)`
};


export {$434ac52446b12663$exports as default};
//# sourceMappingURL=hr-HR.mjs.map
